export class ThemeAppService {

    public isMessageOpen: boolean = false;

    constructor() {
        'ngInject';
    }

}


// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/services/app.service.ts